import { render } from "./EmailVerification.vue?vue&type=template&id=7f79ff2d"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=7f79ff2d&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__